import { getStorage, ref, uploadBytes } from 'firebase/storage';

// lightweight uuidv4 generator
function uuidv4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        const r = (Math.random() * 16) | 0;
        const v = c === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
}

function sanitize(name) {
    return name.replace(/[^a-zA-Z0-9_.-]/g, '_');
}

/**
 * Upload attachments to Firebase Storage under scoped path.
 * files: File[]
 * scope: 'conversation' | 'broadcast'
 * messageId: required
 * conversationId or broadcastId depending on scope
 */
export async function uploadAttachments({ files = [], userId, scope, conversationId, broadcastId, messageId }) {
    if (!Array.isArray(files)) throw new Error('files must be an array');
    if (!userId) throw new Error('userId required');
    if (!messageId) throw new Error('messageId required');
    if (scope !== 'conversation' && scope !== 'broadcast') throw new Error('scope must be conversation or broadcast');

    // Filter out null/undefined files
    const validFiles = files.filter(file => file != null);

    const storage = getStorage();
    const uploadPromises = validFiles.map((file) => {
        const uid = uuidv4();
        const filename = `${uid}-${sanitize(file.name)}`;
        let storagePath = '';
        if (scope === 'conversation') {
            if (!conversationId) throw new Error('conversationId required for conversation scope');
            storagePath = `attachments/${userId}/conversations/${conversationId}/${messageId}/${filename}`;
        } else {
            if (!broadcastId) throw new Error('broadcastId required for broadcast scope');
            storagePath = `attachments/${userId}/broadcasts/${broadcastId}/${filename}`;
        }

        const storageRef = ref(storage, storagePath);
        return uploadBytes(storageRef, file).then(() => ({
            attachmentId: uid,
            storagePath,
            filename: file.name,
            mimeType: file.type || 'application/octet-stream',
            size: file.size,
            source: 'outbound'
        }));
    });

    // Promise.all: abort if any upload fails
    const results = await Promise.all(uploadPromises);
    return results;
}

export default uploadAttachments;
